/**
 * Canonical avatar initials from a display-name string.
 *
 * Contract:
 * - Accepted: string | null | undefined (empty / missing → "")
 * - Rejected without throwing: number, object, array, boolean
 *   (do NOT coerce objects via String(value) — that yields "[object Object]")
 *
 * Examples:
 * - "Silvia Kohuláková" → "SK"
 * - "Štefan" → "Š"
 * - "" / null / undefined → ""
 */
export function getUserInitials(displayName) {
  if (displayName == null || displayName === '') return '';
  if (typeof displayName !== 'string') return '';
  const all_names = displayName.trim().split(' ').filter(Boolean);
  if (all_names.length === 0) return '';
  return all_names.length === 3
    ? all_names.reduce((acc, curr, index) => {
        if (index === all_names.length - 2 || index === all_names.length - 1) {
          acc = `${acc}${curr.charAt(0).toUpperCase()}`;
        }
        return acc;
      }, '')
    : all_names.reduce((acc, curr, index) => {
        if (index === 0 || index === all_names.length - 1) {
          acc = `${acc}${curr.charAt(0).toUpperCase()}`;
        }
        return acc;
      }, '');
}
